import Vue from "vue";

export default Vue.extend({
  template: `<router-link
    :to="{ name: 'Orders', params: { orderNumber: orderNumber } }"
    :target ="target"
    :class="style"
  >
    {{ orderNumber }}
  </router-link>`,

  data: function() {
    return {
      style: "text-blue-500 hover:text-blue-800",
    };
  },
  beforeCreate() {},
  beforeMount() {},
  computed: {
    orderNumber() {
      return this.params.value;
    },
    target() {
      if (this.params.target) {
        return this.params.target;
      }
      return "_self";
    },
  },
  mounted() {
    this.style = this.getStyle();
  },
  methods: {
    getStyle() {
      return this.params.style ? this.params.style : this.style;
    },
  },
});
